// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2nIvJ","legacyBtn":"MutateMid_legacyBtn__1UsuK"};